/** Based on Mass PFML: https://github.com/navapbc/archive-massgov-pfml/blob/main/portal/src/components/mayflower/SiteLogo.tsx */

import Image from 'next/image';
import React from 'react';

import CustomLink from 'src/components/CustomLink';

interface ImageProps {
  src: string;
  alt: string;
  width: number;
  height: number;
}
interface SiteLogoProps {
  url: string;
  title?: string;
  linkAriaLabel?: string;
  image: ImageProps;
  siteName?: string;
}

const SiteLogo = (props: SiteLogoProps) => {
  return (
    <React.Fragment>
      <div className="ma__site-logo">
        <CustomLink href={props.url} title={props.title} aria-label={props.linkAriaLabel}>
          <Image
            alt={props.image.alt}
            src={props.image.src}
            height={props.image.height}
            width={props.image.width}
            className="ma__image"
          />
          {props.siteName && <span style={{ fontSize: 24 }}>{props.siteName}</span>}
        </CustomLink>
      </div>
    </React.Fragment>
  );
};

export default SiteLogo;
